export default __webpack_public_path__ + "static/media/Sprightly Pirate Pendant.299192a7.jpg";